import { Col, DatePicker, Form, Select } from "antd";
import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import { GET_INVENTORY_MRR_REPORT } from "../../../apiServices/API_ENDPOINTS";
import { getData } from "../../../apiServices/common";
import { isArrayAndHasValue } from "../../../utils/functions";
import CustomDatePicker from "common/CustomDatePicker";

const InventoryMRRFilterFields = ({ initialTableData }) => {
  // UX sweep default (fix round 1): last 7 days ending today. Used only by
  // "inventory_mrr" (this page), so an unconditional default is safe.
  // Final fix wave (I2): computed inside the component body (not module scope) so a
  // long-open tab re-evaluates "today" on the next render instead of freezing it at the
  // moment the JS bundle first loaded.
  const DEFAULT_START_DATE = moment().subtract(6, "days").format("YYYY-MM-DD");
  const DEFAULT_END_DATE = moment().format("YYYY-MM-DD");
  // States
  const [suppliersList, setSuppliersList] = useState(null);

  // Antd
  const { Option } = Select;

  const getAllMRR = useCallback(async (value = null) => {
    let query = `${GET_INVENTORY_MRR_REPORT}`;
    if (value) query = `${GET_INVENTORY_MRR_REPORT}?supplier_id=${value}`;

    const response = await getData(query);

    if (response?.status === 200) {
      setSuppliersList(response?.data?.data?.suppliers);
    }
  }, []);

  useEffect(() => {
    getAllMRR();
  }, []);

  return (
    <>
      <Col span={4}>
        <Form.Item
          label="Start Date"
          name="start_date"
          required
          initialValue={DEFAULT_START_DATE}
          rules={[
            {
              required: true,
              message: "Start Date is required",
            },
          ]}
        >
          <CustomDatePicker style={{ width: "100%" }} size="small" />
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item
          label="End Date"
          name="end_date"
          required
          initialValue={DEFAULT_END_DATE}
          rules={[
            {
              required: true,
              message: "End Date is required",
            },
          ]}
        >
          <CustomDatePicker style={{ width: "100%" }} size="small" />
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item
          label="Suppliers"
          name="supplier_id"
          required
          rules={[
            {
              required: true,
              message: "Supplier is required",
            },
          ]}
        >
          <Select
            showSearch
            placeholder="Select an supplier"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children[0].toLowerCase().includes(input.toLowerCase())
            }
            size="small"
            onSearch={getAllMRR}
          >
            {isArrayAndHasValue(suppliersList) &&
              suppliersList.map((supplier) => (
                <Option value={supplier.id} key={supplier.id}>
                  {supplier.name}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>
    </>
  );
};

export default InventoryMRRFilterFields;
